/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/partials/paginator.scss';

const propTypes = {
    currentPage: PropTypes.number,
    lastPage: PropTypes.number,
    // total: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    currentPage: null,
    lastPage: null,
    // total: null,
    className: null,
};

const Paginator = ({ currentPage, lastPage, onClick, className }) => {
    if (lastPage < 2) return null;
    const items = [...Array(Math.floor(lastPage)).keys()];
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {items.map(i => (
                    <button
                        className={classNames([
                            styles.button,
                            {
                                [styles.current]: i + 1 === currentPage,
                            },
                        ])}
                        key={`page-${i}`}
                        type="button"
                        onClick={() => {
                            onClick(i + 1);
                        }}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>
        </div>
    );
};

Paginator.propTypes = propTypes;
Paginator.defaultProps = defaultProps;

export default Paginator;
